import Container from "react-bootstrap/Container";
import React, { useState, useEffect } from "react";
import { AtomStructure, Atom } from "../AtomicStructure";

// X3D view
const X3DAtoms = ({ structureData, viewDistanceMult }) => {
  // Load X3D JS
  useEffect(() => {
    const script = document.createElement("script");

    script.src = "/x3dom.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (structureData !== null && structureData !== undefined) {
    var atomsView = new AtomStructure(structureData, viewDistanceMult);
  }

  return (
    <Container>
      <link
        rel="stylesheet"
        type="text/css"
        href="http://www.x3dom.org/download/x3dom.css"
      ></link>
      <x3d height="400px">
        <scene>
          {atomsView ? (
            atomsView.getScene()
          ) : (
            <div style={{ position: "relative", height: "400px" }}>
              <div
                style={{ position: "absolute", top: "45%" }}
                class="spinner-border text-info"
                role="status"
              >
                {" "}
                <span class="sr-only"></span>{" "}
              </div>
            </div>
          )}
        </scene>
      </x3d>
    </Container>
  );
};

export default X3DAtoms;
